import { View, SxProp } from "dripsy";
import Animated from "react-native-reanimated";
import { useAnimatedProgressBar } from "./useAnimatedProgressBar.hook";
import { useProgressBar } from "./useProgressBar.hook";

interface ProgressBarProps {
  index: number;
  isFirst: boolean;
  isLast: boolean;
  isActive: boolean;
}

export const ProgressBar: React.FC<ProgressBarProps> = (props) => {
  const { index, isFirst, isLast, isActive } = props;

  const {
    barTopStyle,
    barBottomStyle,
    baseAnimatedStatusBarStyle,
    baseAnimatedDotStyle,
    inactiveDotStyle,
    colors,
  } = useProgressBar(props);

  const {
    animatedDotStyle,
    animatedBarTopStyle,
    animatedBarBottomStyle,
    onBarLayoutChange,
  } = useAnimatedProgressBar({
    ...colors,
    index,
    isActive,
  });

  return (
    <View sx={styles.container}>
      <View
        sx={{ ...barTopStyle, position: "relative" }}
        onLayout={onBarLayoutChange}
      >
        {isActive && !isFirst && (
          <Animated.View
            style={[baseAnimatedStatusBarStyle, animatedBarTopStyle]}
          />
        )}
      </View>
      {isActive && (
        <Animated.View style={[baseAnimatedDotStyle, animatedDotStyle]} />
      )}
      {!isActive && <View sx={inactiveDotStyle} />}
      <View
        sx={{ ...barBottomStyle, position: "relative" }}
        onLayout={onBarLayoutChange}
      >
        {isActive && !isLast && (
          <Animated.View
            style={[baseAnimatedStatusBarStyle, animatedBarBottomStyle]}
          />
        )}
      </View>
    </View>
  );
};

enum StyleName {
  container = "container",
}

const styles: Record<StyleName, SxProp> = {
  container: {
    width: "$4",
    alignItems: "center",
  },
};
